module.exports = __webpack_public_path__ + "img/2025-01-09b_2.4df53b7b.jpg";